export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Upcoming Games From E3 2018",
    "shortTitle": "",
    "description": "",
    "width": 1200,
    "height": 848,
    "currentLanguage": "EN",
    "languages": [],
    "basePath": "/6ofthebest/e3-games",
    "companyLogo": "logo.png",
    "publishURL": "https://publish.ironstone.ltd/6ofthebest/e3-games/static/_thumbs",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": false,
      "mobileSwitch": false
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "6 Of The Best",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      <img style="position:absolute; top: 67px; left: 385px;" class="1-title halfScale" src="/6ofthebest/e3-games/static/_content/1-title.png" id="1-title">
      <img style="position:absolute; top: 221px; left: 345px;" class="1-title halfScale" src="/6ofthebest/e3-games/static/_content/1-title-2.png" id="1-title-2">

      <img style="position:absolute; top: 363px; left: -90px;" class="1-img halfScale" src="/6ofthebest/e3-games/static/_content/t-img1.png" id="1-img1">
      <img style="position:absolute; top: 363px; left: 127px;" class="1-img halfScale" src="/6ofthebest/e3-games/static/_content/t-img2.png" id="1-img2">
      <img style="position:absolute; top: 363px; left: 338px;" class="1-img halfScale" src="/6ofthebest/e3-games/static/_content/t-img3.png" id="1-img3">
      <img style="position:absolute; top: 363px; left: 555px;" class="1-img halfScale" src="/6ofthebest/e3-games/static/_content/t-img4.png" id="1-img4">
      <img style="position:absolute; top: 363px; left: 770px;" class="1-img halfScale" src="/6ofthebest/e3-games/static/_content/t-img5.png" id="1-img5">
      <img style="position:absolute; top: 363px; left: 985px;" class="1-img halfScale" src="/6ofthebest/e3-games/static/_content/t-img6.png" id="1-img6">
      `,
      "script": `
        function onPageEnter() {
        
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-title"), 0.8, {opacity:0, y:-150},{opacity:1, y:0, ease: Power4.easeOut}, 0.5, "-=0.4")
                 .staggerFromTo(cOf("1-img"), 0.4, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, 0.2, "-=0.2")
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "SIX OF THE BEST  OF THE BEST UPCOMING E3 GAMES © engadget.com  © pakgn.com  © dailystar.co.uk  © store.steampo  © webdnet.com  © marvel"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Welcome",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 101px; left: 470px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/2-title.png" id="2-title">

      <div id="2-sig" class="abs noOverflow" style="top:536px;left:517px;height:63px;width:168px">
        <img class="halfScale" src="/6ofthebest/e3-games/static/_content/2-sig.png">
      </div>

      
      <img style="position:absolute; top: 676px; left: 524px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/2-logo.png" id="2-logo">

      <div class="contentLink" style="top: 480px; left: 777px; width: 172px; height: 24px;">
        <a href="http://www.e3expo.com" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.fromTo(idOf("2-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("2-sig"), 0.6, {width:"0px"}, {width:"168px", ease: Power2.easeOut}, "-=0.4")
                 .fromTo(idOf("2-logo"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2", addContentLinks)

        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks
        }
      `,
      "searchText": "Welcome Welcome to Six of The Best. For this edition our Team have hand-picked six of their favourite games featured in this year’s E3, We have picked games from a variety of consoles, to excite all age ranges and also bring some nostalgia to those who have grown up with previous installments of the games. This year’s E3 has shown us just how great the gaming industry currently is and the potential it has to improve. If you wish to learn more about each of these games, head to www.e3expo.com.  On Behalf of Six of the best online"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Black Ops 4",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      
      
      <iframe width="1201" height="520" src="https://www.youtube.com/embed/XyAaKRb53Q4?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      

      <img style="position:absolute; top: 573px; left: 301px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/3-title.png" id="3-title">
      <img style="position:absolute; top: 673px; left: 221px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/3-text.png" id="3-text">
      
      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.fromTo(idOf("3-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("3-text"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")

        }

        function onPageLeave() {
          pg3Anim.stop();
        }
      `,
      "searchText": "Black Ops 4 Black Ops is back! Featuring gritty, grounded, fluid Multiplayer combat, the biggest Zombies offering ever with three full undead adventures at launch, and Blackout, where the universe of Black Ops comes to life in one massive battle royale experience featuring the largest map in Call of Duty history, signature Black Ops combat, characters, locations and weapons from the entire Black Ops series."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Black Ops 4",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 454px; left: 0px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img1.png" id="4-img1">
      <img style="position:absolute; top: 454px; left: 800px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img7.png" id="4-img7">

      <img style="position:absolute; top: 226px; left: 0px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img2.png" id="4-img2">
      <img style="position:absolute; top: 227px; left: 800px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img6.png" id="4-img6">

      <img style="position:absolute; top: 0px; left: 0px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img3.png" id="4-img3">
      <img style="position:absolute; top: 0px; left: 800px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img5.png" id="4-img5">

      <img style="position:absolute; top: 0px; left: 400px;" class="4-img halfScale" src="/6ofthebest/e3-games/static/_content/4-img4.png" id="4-img4">

      <div id="4-box" class="abs noOverflow" style="top:227px;left:400px;height:455px;width:400px; background-color:#000000">
        
      </div>
      <img style="position:absolute; top: 255px; left: 446px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/4-title.png" id="4-title">
      <img style="position:absolute; top: 336px; left: 424px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/4-text.png" id="4-text">

      <img style="position:absolute; top: 743px; left: 89px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/4-date.png" id="4-date">
      <img style="position:absolute; top: 757px; left: 772px;" class="halfScale 4-con" src="/6ofthebest/e3-games/static/_content/4-xbox.png" id="4-xbox">
      <img style="position:absolute; top: 753px; left: 922px;" class="halfScale 4-con" src="/6ofthebest/e3-games/static/_content/4-ps4.png" id="4-ps">
      <img style="position:absolute; top: 754px; left: 1079px;" class="halfScale 4-con" src="/6ofthebest/e3-games/static/_content/4-pc.png" id="4-pc">
      
      `,
      "script": `
      function onPageEnter() {
        pg4Anim = new TimelineMax();
        pg4Anim.fromTo(idOf("4-img4"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, 0.4)
               .fromTo(idOf("4-img3"), 0.6, {opacity:0, x:300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("4-img5"), 0.6, {opacity:0, x:-300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("4-img2"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("4-img6"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("4-img1"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("4-img7"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("4-box"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("4-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("4-text"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")

               .fromTo(idOf("4-date"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
               .staggerFromTo(cOf("4-con"), 0.4, {opacity:0},{opacity:1,  ease: Power2.easeOut}, 0.2, "-=0.2")

      }

      function onPageLeave() {
        pg4Anim.stop();
      }
      `,
      "searchText": "© pushsquare.com  © dexerto.com  © heavy.com  Mark’s Opinion After being disappointed with World at War, finding the game play slow and monotonous, I am thrilled to see a return to the first paced Black Ops. Based on the content provided the multiplayer game looks slick, and I am excited to get a hold of the game.  © vgr.com  © forbes.com  The Zombie game mode is also a welcome return, while the battle royale mode I believe could be a hit as long as they have stayed true to the Black Ops games.  Release Date: 12th October 2018  © pakgn.com  © forbes.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Marvel's Spider Man",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      <iframe width="1201" height="520" src="https://www.youtube.com/embed/Pq02p3z3X2k" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      
      <img style="position:absolute; top: 580px; left: 349px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/5-title.png" id="5-title">
      <img style="position:absolute; top: 690px; left: 219px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/5-text.png" id="5-text">
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.fromTo(idOf("5-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("5-text"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg5Anim.stop();
        }
      `,
      "searchText": "Marvel’s Spider Man This isn’t just Spider-Man who has stumbled upon his incredible powers. This is the Peter Parker who’s ever-growing as he becomes the greatest superhero and saviour in New York City. His two lives are colliding together. He attempts to balance his career but also save the thousands of lives in New York City that are in danger."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Marvel's Spider Man",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 454px; left: 0px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img1.png" id="6-img1">
      <img style="position:absolute; top: 454px; left: 800px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img7.png" id="6-img7">

      <img style="position:absolute; top: 226px; left: 0px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img2.png" id="6-img2">
      <img style="position:absolute; top: 227px; left: 800px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img6.png" id="6-img6">

      <img style="position:absolute; top: 0px; left: 0px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img3.png" id="6-img3">
      <img style="position:absolute; top: 0px; left: 800px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img5.png" id="6-img5">

      <img style="position:absolute; top: 0px; left: 400px;" class="6-img halfScale" src="/6ofthebest/e3-games/static/_content/6-img4.png" id="6-img4">
      
      <div id="6-box" class="abs noOverflow" style="top:227px;left:400px;height:455px;width:400px; background-color:#000000">
        
      </div>
      <img style="position:absolute; top: 243px; left: 453px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/6-title.png" id="6-title">
      <img style="position:absolute; top: 320px; left: 425px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/6-text.png" id="6-text">

      <img style="position:absolute; top: 743px; left: 163px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/6-date.png" id="6-date">
      <img style="position:absolute; top: 753px; left: 886px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/4-ps4.png" id="6-ps">
      
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
        pg6Anim.fromTo(idOf("6-img4"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, 0.4)
               .fromTo(idOf("6-img3"), 0.6, {opacity:0, x:300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("6-img5"), 0.6, {opacity:0, x:-300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("6-img2"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("6-img6"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("6-img1"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("6-img7"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("6-box"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("6-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("6-text"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")
               
               .fromTo(idOf("6-date"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
               .fromTo(idOf("6-ps"), 0.4, {opacity:0},{opacity:1, ease: Power2.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg6Anim.stop();
        }
      `,
      "searchText": "Alex’s Opinion The only two interesting things about it is 1) the mystery character mentioned twice in the trailer mentioned by mister negative and spiderman The villains are all apparently working for a mystery character whom spiderman sees off screen at the end of the trailer and exclaims ‘wait, you?’ We also get manual web swinging involving well timed aiming and button presses to get spidey to move in the way that we want him to which can take a whole lot of skill and be a great deal of fun.  Release Date: 7th September 2018"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Pokemon: Let's Go",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      <iframe width="1201" height="520" src="https://www.youtube.com/embed/9jRtpMKLsts" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      
      <img style="position:absolute; top: 585px; left: 377px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/7-title.png" id="7-title">
      <img style="position:absolute; top: 707px; left: 226px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/7-text.png" id="7-text">
      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(idOf("7-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("7-text"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg7Anim.stop();
        }
      `,
      "searchText": "Pokemon: Let’s Go Pokémon: Let’s Go, Pikachu! and Pokémon: Let’s Go, Eevee! bring the experience of a classic Pokémon RPG to Nintendo Switch with gameplay that is easily approachable for newcomers to the series, but is also deep enough to keep veteran Trainers on their toes."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Pokemon: Let's Go",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 455px; left: 0px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img1.png" id="8-img1">
      <img style="position:absolute; top: 455px; left: 800px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img7.png" id="8-img7">

      <img style="position:absolute; top: 227px; left: 0px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img2.png" id="8-img2">
      <img style="position:absolute; top: 227px; left: 800px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img6.png" id="8-img6">

      <img style="position:absolute; top: 0px; left: 0px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img3.png" id="8-img3">
      <img style="position:absolute; top: 0px; left: 800px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img5.png" id="8-img5">

      <img style="position:absolute; top: 0px; left: 400px;" class="8-img halfScale" src="/6ofthebest/e3-games/static/_content/8-img4.png" id="8-img4">

      <div id="8-box" class="abs noOverflow" style="top:228px;left:400px;height:455px;width:400px; background-color:#000000">
        
      </div>
      <img style="position:absolute; top: 265px; left: 430px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/8-title.png" id="8-title">
      <img style="position:absolute; top: 360px; left: 424px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/8-text.png" id="8-text">

      <img style="position:absolute; top: 743px; left: 162px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/8-date.png" id="8-date">
      <img style="position:absolute; top: 745px; left: 896px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/8-nintendo.png" id="8-nin">
      
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(idOf("8-img4"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, 0.4)
               .fromTo(idOf("8-img3"), 0.6, {opacity:0, x:300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("8-img5"), 0.6, {opacity:0, x:-300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("8-img2"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("8-img6"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("8-img1"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("8-img7"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("8-box"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("8-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("8-text"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")

               .fromTo(idOf("8-date"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
               .fromTo(idOf("8-nin"), 0.4, {opacity:0},{opacity:1, ease: Power2.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg8Anim.stop();
        }
      `,
      "searchText": "© e3.nintendo.com  © pokemon.com  © pokemon.com  © ign.com  Kieran’s Opinion ©goombastomp.com  Having grown up playing Pokemon, it is amazing seeing just how far it has come after all these years. This game is a really exciting concept for me as it involves the immersive story of the pokemon games but also includes Pokemon GO still catching system. They have also included a co-op feautre which was stuff of dreams back in the early days of Pokemon.  © comicbook.com  © nintendolife.com  Release Date: 16th November 2018"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Beyond Good and Evil 2",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      
      <iframe width="1201" height="520" src="https://www.youtube.com/embed/IsoIUHDrPcg" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

      <img style="position:absolute; top: 585px; left: 312px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/9-title.png" id="9-title">
      <img style="position:absolute; top: 707px; left: 224px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/9-text.png" id="9-text">
      
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(idOf("9-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("9-text"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg9Anim.stop();
        }
      `,
      "searchText": "Beyond Good and Evil 2 Fight alongside unforgettable characters in a stunning new solar system, as you struggle for freedom and the right to determine your own fate among the stars."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Beyond Good and Evil 2",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 455px; left: 0px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img1.png" id="10-img1">
      <img style="position:absolute; top: 455px; left: 800px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img7.png" id="10-img7">

      <img style="position:absolute; top: 227px; left: 0px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img2.png" id="10-img2">
      <img style="position:absolute; top: 227px; left: 800px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img6.png" id="10-img6">

      <img style="position:absolute; top: 0px; left: 0px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img3.png" id="10-img3">
      <img style="position:absolute; top: 0px; left: 800px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img5.png" id="10-img5">

      <img style="position:absolute; top: 0px; left: 400px;" class="10-img halfScale" src="/6ofthebest/e3-games/static/_content/10-img4.png" id="10-img4">
      
      <div id="10-box" class="abs noOverflow" style="top:228px;left:400px;height:455px;width:400px; background-color:#000000">
        
      </div>
      <img style="position:absolute; top: 275px; left: 446px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/10-title.png" id="10-title">
      <img style="position:absolute; top: 370px; left: 424px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/10-text.png" id="10-text">

      <img style="position:absolute; top: 743px; left: 163px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/10-date.png" id="10-date">
      <img style="position:absolute; top: 743px; left: 763px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/10-date-tbc.png" id="10-date-tbc">
      
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.fromTo(idOf("10-img4"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, 0.4)
               .fromTo(idOf("10-img3"), 0.6, {opacity:0, x:300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("10-img5"), 0.6, {opacity:0, x:-300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("10-img2"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("10-img6"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("10-img1"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("10-img7"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("10-box"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("10-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("10-text"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")

               .fromTo(idOf("10-date"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
               .fromTo(idOf("10-date-tbc"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
          
        }

        function onPageLeave() {
          pg10Anim.stop();
        }
      `,
      "searchText": "© dailystar.co.uk  © gamespot.com  © pcgamer.com  © windowscentral.com  Mark’s Opinion © destructiod.com  Starting off as a low level pirate with nothing to your name, I am looking forward to building my character up and moulding them into a great character through the gaame. Beyond Good and Evil 2 has focused strongly on scale, with the ability to not just travel into different cities but to travel across planets, allowing the player to feel the scale of the open world.  © arstechnica.com  Release Date: TBA  © cnet.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Total War: Three Kingdoms",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      
      <iframe width="1201" height="520" src="https://www.youtube.com/embed/hhhHecSt3LM" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

      <img style="position:absolute; top: 544px; left: 270px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/11-title.png" id="11-title">
      <img style="position:absolute; top: 628px; left: 64px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/11-text.png" id="11-text">

      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.fromTo(idOf("11-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("11-text"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg11Anim.stop();
        }
      `,
      "searchText": "Total War: Three Kingdoms The Han Dynasty crumbles before the child-emperor. He is but a figurehead; a mere puppet for the tyrant warlord Dong Zhuo. It is a brutal and oppressive regime, and as Dong Zhuo’s power grows, the empire slips further into the cauldron of anarchy. But hope yet blossoms. Three heroes, sworn to brotherhood in the face of tyranny, rally support for the trials ahead. Scenting opportunity, warlords from China’s great families follow suit, forming a fragile coalition in a bid to challenge Dong Zhuo’s remorseless rule. Will they triumph against the tyrant, or will personal ambition shatter their already crumbling alliance and drive them to supremacy?"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Total War: Three Kingdoms",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 453px; left: 0px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img1.png" id="12-img1">
      <img style="position:absolute; top: 453px; left: 800px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img7.png" id="12-img7">

      <img style="position:absolute; top: 227px; left: 0px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img2.png" id="12-img2">
      <img style="position:absolute; top: 227px; left: 800px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img6.png" id="12-img6">

      <img style="position:absolute; top: 0px; left: 0px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img3.png" id="12-img3">
      <img style="position:absolute; top: 0px; left: 800px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img5.png" id="12-img5">

      <img style="position:absolute; top: 0px; left: 400px;" class="12-img halfScale" src="/6ofthebest/e3-games/static/_content/12-img4.png" id="12-img4">
      
      
      <div id="12-box" class="abs noOverflow" style="top:227px;left:400px;height:454px;width:400px; background-color:#000000">
        
      </div>
      <img style="position:absolute; top: 275px; left: 446px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/12-title.png" id="12-title">
      <img style="position:absolute; top: 370px; left: 424px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/12-text.png" id="12-text">
      

      <img style="position:absolute; top: 743px; left: 163px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/12-date.png" id="12-date">
      
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(idOf("12-img4"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, 0.4)
               .fromTo(idOf("12-img3"), 0.6, {opacity:0, x:300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("12-img5"), 0.6, {opacity:0, x:-300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("12-img2"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("12-img6"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("12-img1"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("12-img7"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("12-box"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("12-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("12-text"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")

               .fromTo(idOf("12-date"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg12Anim.stop();
        }
      `,
      "searchText": "© store.steampowered.com  © store.steampowered.com  © store.steampowered.com  Tom’s Opinion ©store.steampowered.com  Utilising a little touched region in the Total War franchise, the new iteration puts the player in the heart of China, during the period made famous by the Romance of the Three Kingdom novels. Fight your way through the fall of the Han dynasty and it’s subsequent rebellions, to lead your family to the throne of the Chinese Empire.  © store.steampowered.com © store.steampowered.com  © store.steampowered.com  Release Date: 16th November 2018"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Kingdom Hearts 3",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      <iframe width="1201" height="520" src="https://www.youtube.com/embed/GWlKEM3m2EE" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

      <img style="position:absolute; top: 570px; left: 377px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/13-title.png" id="13-title">
      <img style="position:absolute; top: 673px; left: 222px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/13-text.png" id="13-text">
      
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.fromTo(idOf("13-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.4)
                 .fromTo(idOf("13-text"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
        }

        function onPageLeave() {
          pg13Anim.stop();
        }
      `,
      "searchText": "Kingdom Hearts 3 KINGDOM HEARTS III tells the story of the power of friendship as Sora and his friends embark on a perilous adventure. Set in a vast array of Disney and Pixar worlds, KINGDOM HEARTS follows the journey of Sora, a young boy and unknowing heir to a spectacular power. Sora is joined by Donald Duck and Goofy to stop an evil force known as the Heartless from invading and overtaking the universe."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Kingdom Hearts 3",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 455px; left: 0px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img1.png" id="14-img1">
      <img style="position:absolute; top: 455px; left: 800px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img7.png" id="14-img7">

      <img style="position:absolute; top: 227px; left: 0px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img2.png" id="14-img2">
      <img style="position:absolute; top: 227px; left: 800px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img6.png" id="14-img6">

      <img style="position:absolute; top: 0px; left: 0px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img3.png" id="14-img3">
      <img style="position:absolute; top: 0px; left: 800px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img5.png" id="14-img5">

      <img style="position:absolute; top: 0px; left: 400px;" class="14-img halfScale" src="/6ofthebest/e3-games/static/_content/14-img4.png" id="14-img4">
      
      <div id="14-box" class="abs noOverflow" style="top:228px;left:400px;height:455px;width:400px; background-color:#000000">
        
      </div>
      <img style="position:absolute; top: 283px; left: 430px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/14-title.png" id="14-title">
      <img style="position:absolute; top: 363px; left: 428px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/14-text.png" id="14-text">

      <img style="position:absolute; top: 741px; left: 106px;" class="halfScale" src="/6ofthebest/e3-games/static/_content/14-date.png" id="14-date">
      <img style="position:absolute; top: 757px; left: 796px;" class="halfScale 14-con" src="/6ofthebest/e3-games/static/_content/4-xbox.png" id="14-xbox">
      <img style="position:absolute; top: 752px; left: 946px;" class="halfScale 14-con" src="/6ofthebest/e3-games/static/_content/4-ps4.png" id="14-ps">
      
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
        pg14Anim.fromTo(idOf("14-img4"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, 0.4)
               .fromTo(idOf("14-img3"), 0.6, {opacity:0, x:300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("14-img5"), 0.6, {opacity:0, x:-300 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("14-img2"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("14-img6"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("14-img1"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("14-img7"), 0.6, {opacity:0, y:-200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.6")
               .fromTo(idOf("14-box"), 0.8, {opacity:0},{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("14-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("14-text"), 0.8, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .fromTo(idOf("14-date"), 0.6, {opacity:0, x:-50 },{opacity:1, x:0, ease: Power4.easeOut}, "-=0.3")
               .staggerFromTo(cOf("14-con"), 0.4, {opacity:0},{opacity:1,  ease: Power2.easeOut}, 0.2, "-=0.2")

        }

        function onPageLeave() {
          pg14Anim.stop();
        }
      `,
      "searchText": "© Leviathyn.com  © polygon.com  © cnet.com  © engadget.com  Kieran’s Opinion © techadvisor.co.uk  The third installment of Kingdom Hearts is a highly anticipated release for fans of the series as the 2nd one ends on somewhat of a cliffhanger. I am really excited to find out more about how the story unfolds and if they have made any changes to the game’s mechanics or if they have stayed true to the Kingdom Hearts style that we know and love.  © nerdist.com  Release Date: 25th January 2019  © digitaltrends.com"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "6otb: Presented to you by Ironstone Software LTD",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      
      <img style="position:absolute; top: 90px; left: 450px;" id="15-title" class="halfScale" src="/6ofthebest/e3-games/static/_content/15-title.png" >
      <img style="position:absolute; top: 166px; left: 354px;" id="15-sub" class="halfScale" src="/6ofthebest/e3-games/static/_content/15-sub.png" >

     <div class="contentLink" style="top: 233px; left: 375px; width: 112px; height: 73px;">
        <a href="http://www.sotb.online" target="_blank"></a>
      </div>
      <img style="position:absolute; top: 234px; left: 373px;" class="halfScale 15-logo" src="/6ofthebest/e3-games/static/_content/15-6otb-logo.png" >

     <div class="contentLink" style="top: 241px; left: 672px; width: 155px; height: 65px;">
        <a href="http://www.ironstone.ltd" target="_blank"></a>
      </div>
      <img style="position:absolute; top: 242px; left: 674px;" class="halfScale 15-logo" src="/6ofthebest/e3-games/static/_content/15-is-logo.png" >

     <img style="position:absolute; top: 368px; left: 67px;" class="halfScale 15-img" src="/6ofthebest/e3-games/static/_content/15-img1.jpg" >
      <img style="position:absolute; top: 355px; left: 450px;" class="halfScale 15-img" src="/6ofthebest/e3-games/static/_content/15-img2.jpg" >
      <img style="position:absolute; top: 375px; left: 801px;" class="halfScale 15-img" src="/6ofthebest/e3-games/static/_content/15-img3.png" >

     <img style="position:absolute; top: 607px; left:197px;" class="halfScale" id="15-text" src="/6ofthebest/e3-games/static/_content/15-text.png" >

    
      <img style="position:absolute; top: 751px; left:242px;" class="halfScale 15-url" src="/6ofthebest/e3-games/static/_content/15-url1.png" >
      <div class="contentLink" style="top: 750px; left: 241px; width: 260px; height: 22px;">
        <a href="http://www.sotb.online" target="_blank"></a>
      </div>

      <img style="position:absolute; top: 751px; left:663px;" class="halfScale 15-url" src="/6ofthebest/e3-games/static/_content/15-url2.png" >
      <div class="contentLink" style="top: 750px; left: 661px; width: 300px; height: 22px;">
        <a href="http://www.ironstone.ltd" target="_blank"></a>
      </div>

      <div class="contentLink" style="top: 230px; left: 371px; width: 120px; height: 77px;">
        <a href="http://www.sotb.online" target="_blank"></a>
      </div>

      <div class="contentLink" style="top: 230px; left: 661px; width: 170px; height: 82px;">
        <a href="http://www.ironstone.ltd" target="_blank"></a>
      </div>

      `,
      "script": `
      function onPageEnter() {
      pg15Anim = new TimelineMax();
        pg15Anim.fromTo(idOf("15-title"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 0.5)
                .fromTo(idOf("15-sub"), 0.6, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, "-=0.2")
                .staggerFromTo(cOf("15-logo"), 0.6, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")
                .staggerFromTo(cOf("15-img"), 0.8, {y:-60, opacity:0 },{y:0, opacity:1, ease: Power4.easeOut}, "-=0.2")
                .fromTo(idOf("15-text"), 0.6, {opacity:0 },{opacity:1, ease: Power4.easeOut}, "-=0.2")
               .staggerFromTo(cOf("15-url"), 0.6, {opacity:0, y:200 },{opacity:1, y:0, ease: Power4.easeOut}, "-=0.3",addContentLinks)
        }

        function onPageLeave() {
          pg15Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "Six Of The Best is presented to you by Ironstone Software LTD SIX OF THE BEST  We are a software development company based in Northamptonshire. We design and build websites, digital magazines and bespoke software tailored to you, to bring the best out of your business. There are two things we want you to know - we treat every job like its our first and we will help in any way we can.  WWW.SOTB.ONLINE WWW.IRONSTONE.LTD"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js